module.exports = __webpack_public_path__ + "store-availability-stock-low/store-availability-stock-low-3404a9ffad1ce574a15f2e2e26ca5d47.svg";